export default __webpack_public_path__ + "static/og-image-8175b99bf2c25dc31531bf53ca309a90.png";